export default __webpack_public_path__ + "static/media/bag-empty.87b5b265.svg";